export default __webpack_public_path__ + "static/media/cb-checked.14c849c4.svg";